module.exports = __webpack_public_path__ + "static/media/m13cr93.76f886be.png";